<template>
  <div :class="$style.activity">
    <h2 id="js-activity-title" :class="$style.title">
      <span class="app-fadeInUp">活动风采</span>
    </h2>
    <div id="js-activity-content">
      <div class="app-fadeInUp">
        <the-activity-gallery-item :data="data" />
      </div>
    </div>
  </div>
</template>

<script>
import fadeMixins from '@/assets/js/fadeMixins'
import TheActivityGalleryItem from './TheActivityGalleryItem'

export default {
  components: { TheActivityGalleryItem },
  mixins: [fadeMixins],
  props: {
    data: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      name: 'activity',
      animateScenesData: ['title', 'content'],
    }
  },
}
</script>

<style lang="less" module>
.activity {
  padding: @padding-base-title 0;
  background-color: #fbfbfb;
}

.title {
  margin-bottom: @padding-title-bot;

  span {
    .subtitle-size(3.44rem, 0.91rem);
    .text-hide();
    display: block;
    margin: 0 auto;
    background: url('./images/activity-title.png') no-repeat;
    background-size: 100% 100%;
  }
}
</style>
